export default __webpack_public_path__ + "static/media/layer6.869ffe04.webp";